import React from 'react';

const Dato = ({ label, value }) => (value ? (
  <div>
    <p className="text-[10px] uppercase tracking-wider text-slate-400 mb-0.5">{label}</p>
    <p className="text-xs font-medium text-slate-800">{value}</p>
  </div>
) : null);

// Datos que trae Waya para el CVU (titular, identidad, límites).
export const CvuWayaDetalle = ({ cvu, idx }) => (
  <div className="px-4 py-3 bg-slate-50/60" data-testid={`cvu-waya-detalle-${idx}`}>
    <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-2">
      <Dato label="Titular" value={cvu.nombre_titular} />
      <Dato label="Tipo cuenta" value={cvu.tipo_cuenta} />
      <Dato label="Identidad" value={cvu.validacion_identidad} />
      <Dato label="Última sesión" value={cvu.ultima_sesion} />
      <Dato label="Lím. diario" value={cvu.limite_diario} />
      <Dato label="Lím. mensual" value={cvu.limite_mensual} />
      <Dato label="Lím. alerta" value={cvu.limite_alerta} />
      <Dato label="Registrado" value={cvu.fecha_registracion} />
      <Dato label="Alta PSP (reporte)" value={cvu.reporte_usuarios?.fecha_alta_psp} />
      <Dato label="Baja (reporte)" value={cvu.reporte_usuarios?.fecha_baja} />
      <Dato label="Usuario en Waya (reporte)" value={cvu.reporte_usuarios?.estado_usuario} />
    </div>
    {cvu.reporte_usuarios?.importado_en && (
      <p className="text-[10px] text-slate-400 mt-2" data-testid={`cvu-reporte-usuarios-${idx}`}>
        Reporte de usuarios Waya importado: {new Date(cvu.reporte_usuarios.importado_en).toLocaleDateString('es-AR')}
      </p>
    )}
    {cvu.waya_actualizado_en && (
      <p className="text-[10px] text-slate-400 mt-2">
        Datos Waya actualizados: {new Date(cvu.waya_actualizado_en).toLocaleString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
      </p>
    )}
  </div>
);
